import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
};

const setInfo = (store, data) => {
  store.setState((state) => {
    state.modulo.fpg.info.data = {
      ...state.modulo.fpg.info.data,
      ...data,
    };
  });
};

const detail = async (store, id, meta = {}) => {
  store.setState((state) => {
    state.modulo.fpg.info.busy = true;
  });

  const params = {
    ...meta,
  };

  try {
    const response = await Http.get(`api/autofacturacion/fpg/${id}`, { params });

    store.setState((state) => {
      state.modulo.fpg.info.busy = false;
      state.modulo.fpg.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.fpg.info.busy = false;
      state.modulo.fpg.info.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.fpg.info.busy = { ...initialState };
  });
};

const resetError = (store) => {
  store.setState((state) => {
    state.modulo.fpg.info.error = undefined;
  });
};

const FacturasGlobalesInfoStore = {
  state: () => initialState,
  actions: {
    setInfo,
    detail,
    reset,
    resetError,
  },
};

export default FacturasGlobalesInfoStore;
